/* AUTAVEX — екошкіра: галереї та фото комплектацій */
window.AV_EK_GAL={
 C:['A9F776F9-C77C-4680-86A2-05EB0A5EC5A3.jpg?v=1786458702',
    '24812D49-B49D-4CA3-A2CB-99457DA262DA.png?v=1786458702',
    '43E72535-FCB2-42A4-861D-8F2D56D4B9E6.png?v=1786458702',
    '73F272A3-3369-4E0F-88B5-4AE42EE75A88.png?v=1786458702',
    '0FA52D6A-3E74-43E4-8AA7-D4B8323A05E1.png?v=1786458703',
    'D66746BE-1E8C-4E36-9F86-6310BC166AC8.jpg?v=1786458702',
    'A471FB2A-3DC8-4D92-902A-EA45DE3B7C7B.jpg?v=1786458702',
    '48D2B656-AB88-4A32-B185-5FA2AEDDD870.png?v=1786458702',
    '86173D8A-B10C-48FD-B3CF-0645F258DDC9.jpg?v=1786458702',
    'F67833D9-F0EF-426C-AC1E-AA18383BF60C.jpg?v=1786458702',
    'AF5690F2-5BA8-4506-B4AB-1F435F039968.jpg?v=1786458702',
    'FullSizeRender_458108c1-6768-462d-8c11-0da1cafbfe3f.jpg?v=1786459383',
    'FullSizeRender_49acd3c8-0ecf-4ed9-992f-17a9b99e4052.jpg?v=1786459382',
    'FullSizeRender_06262eea-f2b6-431e-abb3-befb832cfd09.jpg?v=1786459082',
    'FullSizeRender_65168175-eded-4b0d-9211-6bbcd282ba60.jpg?v=1786459082'],
 P:['7C86FE31-3865-4182-9560-AC4FB81EFF55.jpg?v=1786476240',
    'IMG-3882.jpg?v=1786476201',
    'IMG-3881.jpg?v=1786476201',
    'FBED7A50-C3CB-4617-8C65-B4D4B74408E3.jpg?v=1786476189',
    'BE106C79-DEF3-4EAE-A66D-D29C65B2CD80.png?v=1786476189',
    '430DF0A2-4966-4D2E-81A0-1847603AC089.png?v=1786476189',
    '147B30AF-AF14-4BAD-BE72-DA097E916184.png?v=1786476240',
    'IMG-3901.png?v=1786477004',
    'IMG-3902.png?v=1786477123',
    'IMG-3903.png?v=1786477160',
    'IMG-3905.png?v=1786477220',
    'IMG-3906.png?v=1786477338',
    'IMG-3907.png?v=1786477473',
    'IMG-3908.png?v=1786477473',
    'IMG-3909.png?v=1786477505']
};
/* мінівен і бус — ті самі фото, що й звичайна комплектація */
window.AV_EK_PICS={
 C:{front:'IMG-3780.png?v=1786454547',
    full:'IMG-3782.png?v=1786454547',
    trunk:'IMG-3781.png?v=1786454547',
    mini:'IMG-3782.png?v=1786454547',
    bus:'IMG-3780.png?v=1786454547',
    row3:''},
 P:{front:'IMG-3876.png?v=1786473678',
    full:'IMG-3877.png?v=1786473678',
    trunk:'IMG-3880.png?v=1786473678',
    mini:'IMG-3877.png?v=1786473678',
    bus:'IMG-3876.png?v=1786473678',
    row3:''},
 logo:'IMG-3039.png?v=1786094741',
 heel:'FullSizeRender_b87c0820-b6b0-44fe-8510-f3da419f39ff.jpg?v=1786092970'
};
